export default "__VITE_ASSET__BDGz7CZm__"